// AUTO-GENERATED by scripts/gen-version.mjs from package.json. Do not edit.
export const SDK_NAME = 'web';
export const SDK_VERSION = '0.1.12';
